var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { AnswerFactory } from "./AnswerFactory";
export class Questionnaire {
  constructor(_data) {
    /**
     */
    __publicField(this, "Answers");
    /**
     */
    __publicField(this, "Status");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof Questionnaire
     */
    __publicField(this, "$type", "V1.CompanyInfo.Questionnaire.Questionnaire");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["Answers"] && _data["Answers"].constructor === Array) {
        this.Answers = [];
        for (let item of _data["Answers"]) {
          const $typeAnswers = item && item.$type;
          if ($typeAnswers) {
            const answers_ = AnswerFactory.create($typeAnswers);
            this.Answers.push(answers_.init(item));
          }
        }
      }
      this.Status = QuestionnaireStatus[_data["Status"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.Answers && this.Answers.constructor === Array) {
      _data["Answers"] = [];
      for (let item of this.Answers) {
        _data["Answers"].push(item.toJSON());
      }
    }
    _data["Status"] = QuestionnaireStatus[this.Status];
    return _data;
  }
}
export var QuestionnaireStatus = /* @__PURE__ */ ((QuestionnaireStatus2) => {
  QuestionnaireStatus2["Incomplete"] = "Incomplete";
  QuestionnaireStatus2["Completed"] = "Completed";
  QuestionnaireStatus2["Approved"] = "Approved";
  QuestionnaireStatus2["DataVerified"] = "DataVerified";
  return QuestionnaireStatus2;
})(QuestionnaireStatus || {});
